/** @jsx jsx */
import { jsx } from 'theme-ui';
import React from 'react';
import Layout from '../components/layout';
import { SelectCategories } from '../components/CookieConsent';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import * as analytics from '../utils/analytics';

const CookieSettingsPage = ({ pageContext }) => {
  analytics.usePageCategory('not_set');
  const { t: translate } = useTranslation();

  return (
    <Layout
      title={translate('cookieConsent.categoryTitle')}
      paths={pageContext.paths}
      locale={pageContext.locale || 'en'}
    >
      <SelectCategories hasAcceptButton={false} />
    </Layout>
  );
};

export default CookieSettingsPage;
